import {
  EventCalendarWidget,
  PerformanceWidget,
  QuickActionsWidget,
} from 'modules/shared/components';
import { AnalystProjectList } from 'modules/work-implementation/projects-list';

export default function AnalystHome() {
  return (
    <>
      <div className='column gap-8'>
        <QuickActionsWidget />
        <div className='grid grid--2-cols gap-8'>
          <PerformanceWidget />
          <EventCalendarWidget />
        </div>
      </div>

      <AnalystProjectList />
    </>
  );
}
